import React, { useState, useEffect } from 'react';
import config from '../../config';

const HealthCoach = () => {

	const [coachData, setCoachData] = useState([]);

	useEffect(() => {
	    const fetchCoachData = async () => {
	      try {
	        const response = await fetch(`${config.apiUrl}/healthcoach`);
	        const data = await response.json();
	        setCoachData(data);
	      } catch (error) {
	        console.error('Error fetching Health Coach information', error);
	      }
	    };
	    fetchCoachData();
	  }, []);

	return (
		<div style={{ padding: '0%, 8%', maxWidth: '800px' }}>
            {coachData.length ? (
            	coachData[0].content.map((block, index) => {
            	switch(block.type) {
                	case 'paragraph':
                		return <p key={index}>{block.text}</p>;
                	case 'heading':
                		return <h2 key={index}>{block.text}</h2>;
                	case 'subheading':
                		return <h3 key={index}>{block.text}</h3>;
                	case 'subsubheading':
                		return <h4 key={index}>{block.text}</h4>;
                	case 'unorderedlist':
                		return (
                			<ul key={index}>
                				{block.items.map((item, itemIndex) => (
                					<li key={itemIndex}>{item}</li>
                				))}
                			</ul>);
                	case 'orderedlist':
                		return (
                			<ol key={index}>
                				{block.items.map((item, itemIndex) => (
                					<li key={itemIndex}>{item}</li>
                				))}
                			</ol>);
                	case 'image':
                		return <img key={index} src={block.url} alt={block.alt} />;
                    default:
                        return <p key={index}>{block.text}</p>;
                }})
            	) : (
            		<h2>Loading...</h2>)
            }
		</div>
	)
}

export default HealthCoach;